import { ApiError } from "@trillion/ui/lib/api-client";

// ApiError.body is the raw response text; the API's refusals are {"error": "..."}.
export function serverError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    try {
      const parsed: unknown = JSON.parse(err.body);
      if (parsed && typeof parsed === "object" && "error" in parsed && typeof parsed.error === "string") return parsed.error;
    } catch {
      // body was not JSON — fall through to the generic message
    }
  }
  return fallback;
}
